<template>
    <v-card width="100%">
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-title>
            <v-row>
                <v-col md="3" cols="12">
                    <v-text-field label="Название" v-model="search.name" @keydown.enter="searchFile" clearable />
                </v-col>
                <v-col cols="12" md="3">
                    <v-select label="Где искать?" :items="target" item-value="value" item-text="name"
                        @change="dropResult" v-model="targetData" />
                </v-col>
                <v-col cols="12" md="3">
                    <v-select label="Что искать?" clearable :items="types" item-value="code" item-text="name"
                        v-model="search.type" />
                </v-col>
                <v-col cols="12" md="3" v-if="targetData === 'kinozal'">
                    <v-select label="Год выпуска" :items="years" v-model="search.year" />
                </v-col>
            </v-row>
            <v-col cols="12">
                <span class="alertText" v-if="targetData === 'kinozal' && userData.limit[0] <= userData.limit[1]">Лимит
                    скачивания с
                    Кинозал.TV на сегодня исчерпан.<br />
                    Смените источник поиска на RuTracker.Org</span>
                <v-btn v-else color="#cc7b19" small @click="searchFile">найти</v-btn>
            </v-col>
        </v-card-title>
        <v-card-text>
            <kinozal v-if="targetData === 'kinozal'" />
            <rutracker v-if="targetData === 'rutracker'" />
        </v-card-text>
    </v-card>
</template>

<script>
import kinozal from "@/components/kinozal";
import rutracker from "@/components/rutracker";

export default {
    name: "search",
    components: { kinozal, rutracker },
    data() {
        return {
            overlay: false,
            targetData: 'kinozal',
            tabs: ['Поиск на Кинозал.ТВ', 'Поиск на RuTracker.org'],
            tab: 'Поиск на Кинозал.ТВ',
            types: [
                { 'name': 'Фильмы', 'code': 1002 },
                { 'name': 'Сериалы', 'code': 1001 },
                { 'name': 'Музыка', 'code': 1004 },
            ],
            target: [
                { 'name': 'Кинозал.TV', 'value': 'kinozal' },
                { 'name': 'RuTracker.ORG', 'value': 'rutracker' }
            ],
            search: { 'name': '', 'year': 'Все', 'type': null },
        }
    },
    methods: {
        async checkServer() {
            this.$http.get('/getName').then((resp) => {
                if (resp.data === 'main-station') {
                    this.types.push({ 'name': 'Аудиокниги', 'code': 2 })
                    this.types.push({ 'name': 'Книги', 'code': 41 })
                }
            })
        },
        dropResult() {
            this.$store.commit('SET_RESULT_SEARCH', [])
        },
        async searchFile() {
            if (this.targetData === 'kinozal' && this.userData.limit[0][0] <= this.userData.limit[1][0]) {
                return true
            } else {
                this.$store.commit('SET_RESULT_SEARCH', [])
                this.overlay = true
                if (this.targetData === 'kinozal') {
                    if (this.search.name !== '') {
                        if (this.search.year === 'Все') this.search.year = null
                        await this.$http.post('/searchFile', this.search).then((resp) => {
                            if (resp.data.length === 0) {
                                this.$store.commit('SET_RESULT_TEXT', 'Фильмы не найдены')
                            } else {
                                this.$store.commit('SET_RESULT_TEXT', 'Результаты поиска')
                                this.$store.commit('SET_RESULT_SEARCH', resp.data)
                            }
                        }).catch((error) => {
                            alert(error.response.data)
                        })
                    }
                    this.search.year = 'Все'
                    this.overlay = false
                } else if (this.targetData === 'rutracker') {
                    if (this.search.name !== '') {
                        await this.$http.post('/searchFileRu', this.search).then((resp) => {
                            if (resp.data.length === 0) {
                                this.$store.commit('SET_RESULT_TEXT', 'Фильмы не найдены')
                            } else {
                                this.$store.commit('SET_RESULT_TEXT', 'Результаты поиска')
                                this.$store.commit('SET_RESULT_SEARCH', resp.data)
                            }
                        })
                    }
                    this.search.year = 'Все'
                    this.overlay = false
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch('updateToken')
        this.checkServer()
    },
    destroyed() {
        this.$store.commit('SET_RESULT_SEARCH', [])
    },
    computed: {
        years() {
            const year = new Date().getFullYear()
            let yr = Array.from({ length: year - 1950 }, (value, index) => 1951 + index).reverse()
            yr.unshift('Все')
            return yr
        },
        userData() {
            return this.$store.getters.userData
        }
    }
}
</script>

<style scoped>
.alertText {
    font-size: 15px;
}
</style>
